import React from 'react';
import { Box, Typography } from '@mui/material';
import { Loop } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

export function EmptyHistoryState() {
  const { t } = useTranslation('tasks');

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      py={8}
    >
      <Loop sx={{ fontSize: 64, color: 'text.disabled', mb: 2 }} />
      <Typography variant="h6" color="text.secondary" gutterBottom>
        {t('messages.no_recurrence_history')}
      </Typography>
      <Typography variant="body2" color="text.secondary" align="center">
        {t('messages.first_in_chain')}
      </Typography>
    </Box>
  );
}
